// components/skeletons/SkeletonFeaturedSection.js
export default function SkeletonFeaturedSection() {
  return (
    <section className="features_section section_padding bg-pattern">
      <div className="container">
        <div className="grid grid-cols-12 gap-6 items-center xl:items-start">
          {/* Left List Part */}
          <div className="lg:col-span-6 col-span-12 space-y-6">
            <div className="w-3/4 h-8 bg-gray-300 rounded animate-pulse mb-6"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[1, 2, 3, 4].map((item) => (
                <div
                  key={item}
                  className="feature-item flex items-center cursor-wait py-4"
                  aria-busy="true"
                  aria-label="Loading feature"
                >
                  <div
                    className="w-12 h-12 bg-gray-300 rounded-full animate-pulse"
                    style={{ marginRight: '0.5rem' }} // inline marginRight for test
                  ></div>
                  <div className="h-6 bg-gray-300 rounded w-3/4 animate-pulse"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image Part */}
          <div className="lg:col-span-6 col-span-12 hidden lg:block">
            <div className="feature-img-part w-full h-64 bg-gray-300 rounded animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
